"use client";

import { useI18n } from "@/i18n/I18nProvider";
import { localizedText } from "@/i18n/text";
import { cn } from "@/lib/utils";
import type { CampaignBadgeDTO } from "@/types/campaign";

type Props = {
  badge?: CampaignBadgeDTO | null;
  className?: string;
};

/**
 * The corner tag on an advert card: *there is an offer here*.
 *
 * One word — "Kampanj" — whatever the offer is. The card says what the offer
 * is on the line beside the price; scanning a feed, the only question the
 * corner answers is "does this home have one".
 *
 * A plain white tag, the same as the Express tag beside it, so a card that
 * carries both still reads as one calm row rather than two competing colours.
 */
export default function CampaignCardMark({ badge, className }: Props) {
  const { locale } = useI18n();

  if (!badge) {
    return null;
  }

  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full bg-white/95 px-2.5 py-1 text-xs font-semibold leading-none text-gray-900 shadow-sm",
        className
      )}
    >
      {localizedText(locale, "Kampanj", "Offer")}
    </span>
  );
}
